<template>
    <kt-row style="padding-right: 25px">
        <kt-col lg="8" md="6" xs="12">
            <p class="col-10"
               style="background-color:yellow;border-color: white;border-radius:6px ">
                {{ $t('application.services.inquiry_services') }}
            </p>
          <kt-row>
            <kt-col>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="iban_inquiry-div">
                        <i v-if="form_data.iban_inquiry.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.iban_inquiry.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.iban_inquiry.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="iban_inquiry"
                                name="iban_inquiry"
                                v-model="form_data.iban_inquiry.is_selected"
                        >
                        <label class="custom-control-label" for="iban_inquiry">
                            {{ $t('application.services.iban_inquiry') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="card_to_iban-div">
                        <i v-if="form_data.card_to_iban.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.card_to_iban.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                        <i v-if="form_data.card_to_iban.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="card_to_iban"
                                name="card_to_iban"
                                v-model="form_data.card_to_iban.is_selected"
                        >
                        <label class="custom-control-label" for="card_to_iban">
                            {{ $t('application.services.card_to_iban') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="card_to_account-div">-->
<!--                        <i v-if="form_data.card_to_account.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.card_to_account.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                        <i v-if="form_data.card_to_account.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="card_to_account"-->
<!--                                name="card_to_account"-->
<!--                                v-model="form_data.card_to_account.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label"-->
<!--                               for="card_to_account">-->
<!--                            {{ $t('application.services.card_to_account') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12" sm="12">
                    <div class="custom-control custom-checkbox"
                         id="iban_to_account-div">
                        <i v-if="form_data.iban_to_account.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.iban_to_account.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                        <i v-if="form_data.iban_to_account.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="iban_to_account"
                                name="iban_to_account"
                                v-model="form_data.iban_to_account.is_selected"
                        >
                        <label class="custom-control-label"
                               for="iban_to_account">
                            {{ $t('application.services.iban_to_account') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="account_to_iban-div">
                        <i v-if="form_data.account_to_iban.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.account_to_iban.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                        <i v-if="form_data.account_to_iban.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="account_to_iban"
                                name="account_to_iban"
                                v-model="form_data.account_to_iban.is_selected"
                        >
                        <label class="custom-control-label" for="account_to_iban">
                            {{ $t('application.services.account_to_iban') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12" sm="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="card_owner_information_inquiry-div">-->
<!--                            <i v-if="form_data.card_owner_information_inquiry.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.card_owner_information_inquiry.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                         <i v-if="form_data.card_owner_information_inquiry.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="card_owner_information_inquiry"-->
<!--                                name="card_owner_information_inquiry"-->
<!--                                v-model="form_data.card_owner_information_inquiry.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label"-->
<!--                               for="card_owner_information_inquiry">-->
<!--                            {{ $t('application.services.card_owner_information_inquiry') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="account_owner_name_inquiry-div">-->
<!--                            <i v-if="form_data.account_owner_name_inquiry.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.account_owner_name_inquiry.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                         <i v-if="form_data.account_owner_name_inquiry.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="account_owner_name_inquiry"-->
<!--                                name="account_owner_name_inquiry"-->
<!--                                v-model="form_data.account_owner_name_inquiry.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label" for="account_owner_name_inquiry">-->
<!--                            {{ $t('application.services.account_owner_name_inquiry') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="card_inquiry-div">-->
<!--                            <i v-if="form_data.card_inquiry.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.card_inquiry.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                         <i v-if="form_data.card_inquiry.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="card_inquiry"-->
<!--                                name="card_inquiry"-->
<!--                                v-model="form_data.card_inquiry.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label"-->
<!--                               for="card_inquiry">-->
<!--                            {{ $t('application.services.card_inquiry') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->

            </kt-col>
            <kt-col>
              <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                  <div class="custom-control custom-checkbox"
                       id="matching_national_id_mobile-div">
                    <i v-if="form_data.matching_national_id_mobile.status == applicationServiceStatus.ACTIVE"
                       style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                    <i v-if="form_data.matching_national_id_mobile.status == applicationServiceStatus.PENDING"
                       style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                    <i v-if="form_data.matching_national_id_mobile.status == applicationServiceStatus.BLOCKED"
                       style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="matching_national_id_mobile"
                        name="matching_national_id_mobile"
                        v-model="form_data.matching_national_id_mobile.is_selected"
                    >
                    <label class="custom-control-label"
                           for="matching_national_id_mobile">
                      {{ $t('application.services.matching_national_id_mobile') }}
                    </label>
                  </div>
                </kt-col>
              </kt-row>
              <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12" sm="12">
                  <div class="custom-control custom-checkbox"
                       id="matching_card_national_id_birth_date_inquiry-div">
                    <i v-if="form_data.matching_card_national_id_birth_date_inquiry.status == applicationServiceStatus.ACTIVE"
                       style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                    <i v-if="form_data.matching_card_national_id_birth_date_inquiry.status == applicationServiceStatus.PENDING"
                       style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                    <i v-if="form_data.matching_card_national_id_birth_date_inquiry.status == applicationServiceStatus.BLOCKED"
                       style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="matching_card_national_id_birth_date_inquiry"
                        name="matching_card_national_id_birth_date_inquiry"
                        v-model="form_data.matching_card_national_id_birth_date_inquiry.is_selected"
                    >
                    <label class="custom-control-label"
                           for="matching_card_national_id_birth_date_inquiry">
                      {{ $t('application.services.matching_card_national_id_birth_date_inquiry') }}
                    </label>
                  </div>
                </kt-col>
              </kt-row>
              <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                  <div class="custom-control custom-checkbox"
                       id="matching_iban_national_id_birth_date_inquiry-div">
                    <i v-if="form_data.matching_iban_national_id_birth_date_inquiry.status == applicationServiceStatus.ACTIVE"
                       style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                    <i v-if="form_data.matching_iban_national_id_birth_date_inquiry.status == applicationServiceStatus.PENDING"
                       style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                    <i v-if="form_data.matching_iban_national_id_birth_date_inquiry.status == applicationServiceStatus.BLOCKED"
                       style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="matching_iban_national_id_birth_date_inquiry"
                        name="matching_iban_national_id_birth_date_inquiry"
                        v-model="form_data.matching_iban_national_id_birth_date_inquiry.is_selected"
                    >
                    <label class="custom-control-label" for="matching_iban_national_id_birth_date_inquiry">
                      {{ $t('application.services.matching_iban_national_id_birth_date_inquiry') }}
                    </label>
                  </div>
                </kt-col>
              </kt-row>
              <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                  <div class="custom-control custom-checkbox"
                       id="matching_iban_national_id_inquiry-div">
                    <i v-if="form_data.matching_iban_national_id_inquiry.status == applicationServiceStatus.ACTIVE"
                       style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                    <i v-if="form_data.matching_iban_national_id_inquiry.status == applicationServiceStatus.PENDING"
                       style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                    <i v-if="form_data.matching_iban_national_id_inquiry.status == applicationServiceStatus.BLOCKED"
                       style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="matching_iban_national_id_inquiry"
                        name="matching_iban_national_id_inquiry"
                        v-model="form_data.matching_iban_national_id_inquiry.is_selected"
                    >
                    <label class="custom-control-label"
                           for="matching_iban_national_id_inquiry">
                      {{ $t('application.services.matching_iban_national_id_inquiry') }}
                    </label>
                  </div>
                </kt-col>
              </kt-row>
              <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                  <div class="custom-control custom-checkbox"
                       id="vital_info-div">
                    <i v-if="form_data.vital_info.status == applicationServiceStatus.ACTIVE"
                       style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                    <i v-if="form_data.vital_info.status == applicationServiceStatus.PENDING"
                       style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                    <i v-if="form_data.vital_info.status == applicationServiceStatus.BLOCKED"
                       style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="vital_info"
                        name="vital_info"
                        v-model="form_data.vital_info.is_selected"
                    >
                    <label class="custom-control-label"
                           for="vital_info">
                      {{ $t('application.services.vital_info') }}
                    </label>
                  </div>
                </kt-col>
              </kt-row>
            </kt-col>
          </kt-row>


        </kt-col>
<!--        <kt-col lg="4" md="6" xs="12">-->
<!--            <p class="col-10"-->
<!--               style="background-color: lightgreen;border-color: white;border-radius:6px ">-->
<!--                {{ $t('application.services.authentication_services') }}-->
<!--            </p>-->


<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12" sm="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="postal_code_information-div">-->
<!--                            <i v-if="form_data.postal_code_information.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.postal_code_information.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                         <i v-if="form_data.postal_code_information.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="postal_code_information"-->
<!--                                name="postal_code_information"-->
<!--                                v-model="form_data.postal_code_information.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label"-->
<!--                               for="postal_code_information">-->
<!--                            {{ $t('application.services.postal_code_information') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
<!--        </kt-col>-->
        <kt-col lg="4" md="6" xs="12">
            <p class="col-10"
               style="background-color: rgba(93, 120, 255, 0.1);border-color: white;border-radius:6px ">
                {{ $t('application.services.financial_services') }}
            </p>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="internal_transfer-div">
                            <i v-if="form_data.internal_transfer.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.internal_transfer.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.internal_transfer.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="internal_transfer"
                                name="internal_transfer"
                                v-model="form_data.internal_transfer.is_selected"
                        >
                        <label class="custom-control-label" for="internal_transfer">
                            {{ $t('application.services.internal_transfer') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="paya_transfer-div">
                            <i v-if="form_data.paya_transfer.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.paya_transfer.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.paya_transfer.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="paya_transfer"
                                name="paya_transfer"
                                v-model="form_data.paya_transfer.is_selected"
                        >
                        <label class="custom-control-label"
                               for="paya_transfer">
                            {{ $t('application.services.paya_transfer') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12" sm="12">
                    <div class="custom-control custom-checkbox"
                         id="satna_transfer-div">
                            <i v-if="form_data.satna_transfer.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.satna_transfer.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.satna_transfer.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="satna_transfer"
                                name="satna_transfer"
                                v-model="form_data.satna_transfer.is_selected"
                        >
                        <label class="custom-control-label"
                               for="satna_transfer">
                            {{ $t('application.services.satna_transfer') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="invoice-div">
                            <i v-if="form_data.invoice.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.invoice.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.invoice.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="invoice"
                                name="invoice"
                                v-model="form_data.invoice.is_selected"
                        >
                        <label class="custom-control-label"
                               for="invoice">
                            {{ $t('application.services.invoice') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12" sm="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="satna_report-div">-->
<!--                            <i v-if="form_data.satna_report.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.satna_report.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                         <i v-if="form_data.satna_report.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="satna_report"-->
<!--                                name="satna_report"-->
<!--                                v-model="form_data.satna_report.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label"-->
<!--                               for="satna_report">-->
<!--                            {{ $t('application.services.satna_report') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
<!--            <kt-row class="mb-3">-->
<!--                <kt-col lg="12" md="12" xs="12">-->
<!--                    <div class="custom-control custom-checkbox"-->
<!--                         id="paya_report-div">-->
<!--                            <i v-if="form_data.paya_report.status == applicationServiceStatus.ACTIVE"-->
<!--                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>-->
<!--                        <i v-if="form_data.paya_report.status == applicationServiceStatus.PENDING"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>-->
<!--                         <i v-if="form_data.paya_report.status == applicationServiceStatus.BLOCKED"-->
<!--                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>-->
<!--                        <input-->
<!--                                type="checkbox"-->
<!--                                class="custom-control-input"-->
<!--                                id="paya_report"-->
<!--                                name="paya_report"-->
<!--                                v-model="form_data.paya_report.is_selected"-->
<!--                        >-->
<!--                        <label class="custom-control-label"-->
<!--                               for="paya_report">-->
<!--                            {{ $t('application.services.paya_report') }}-->
<!--                        </label>-->
<!--                    </div>-->
<!--                </kt-col>-->
<!--            </kt-row>-->
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="balance-div">
                            <i v-if="form_data.balance.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.balance.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.balance.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="balance"
                                name="balance"
                                v-model="form_data.balance.is_selected"
                        >
                        <label class="custom-control-label"
                               for="balance">
                            {{ $t('application.services.balance') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="statement-div">
                            <i v-if="form_data.statement.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.statement.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                         <i v-if="form_data.statement.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="statement"
                                name="statement"
                                v-model="form_data.statement.is_selected"
                        >
                        <label class="custom-control-label"
                               for="statement">
                            {{ $t('application.services.statement') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row class="mb-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-checkbox"
                         id="ipg_gateway_transaction_refund-div">
                        <i v-if="form_data.ipg_gateway_transaction_refund.status == applicationServiceStatus.ACTIVE"
                           style="position: absolute;right: -20px;top:4px;color: #1dc9b7" class="fa fa-check-circle"></i>
                        <i v-if="form_data.ipg_gateway_transaction_refund.status == applicationServiceStatus.PENDING"
                           style="position: absolute;right: -20px;top:4px;color:#f59e00" class="fa fa-exclamation-circle"></i>
                        <i v-if="form_data.ipg_gateway_transaction_refund.status == applicationServiceStatus.BLOCKED"
                           style="position: absolute;right: -20px;top:4px;color:#ff464a" class="fa fa-ban"></i>
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="ipg_gateway_transaction_refund"
                            name="ipg_gateway_transaction_refund"
                            v-model="form_data.ipg_gateway_transaction_refund.is_selected"
                        >
                        <label class="custom-control-label"
                               for="ipg_gateway_transaction_refund">
                            {{ $t('application.services.ipg_gateway_transaction_refund') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import {applicationServiceStatus} from '@/constants/openBanking'

export default {
    props: {
        form_data: {
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    data() {
        return {
            applicationServiceStatus
        }
    }
}
</script>

<style>

</style>